import React from 'react'
import flash from '/lib/flash'
import PropTypes from 'prop-types'
import debounce from 'underscore-es/debounce'

# components
import Spinner      from '/components/spinner'

import './styles'

export default \
class TicketmasterPromoter extends React.Component
  @propTypes:
    id:               PropTypes.string
    promoterId:       PropTypes.string
    updatePromoterId: PropTypes.func
    placeholder:      PropTypes.string

  constructor: ->
    super arguments...
    @state =
      promoterId: @props.promoterId || ''
      saving: false

    @debouncedSave = debounce(@savePromoterId, 500)

  handleInputChange: (event) =>
    @setState promoterId: event.target.value
    @debouncedSave()

  savePromoterId: ->
    # Want to save as null if unset
    promoterId = if @state.promoterId == '' then null else @state.promoterId

    @setState saving: true
    @props.updatePromoterId(@props.id, promoterId)
      .then (result) =>
        {errors} = result
        if errors?.length
          flash.error(errors)
        else
          flash.success("Promoter ID updated successfully")
      .catch (err) =>
        flash.error("Failed to update Promoter ID")
      .finally =>
        @setState saving: false

  render: ->
    <div className="TicketmasterPromoter">
      <section>
        <div className="input-wrapper">
          <input
            type="text"
            className="form-control input-sm"
            value={@state.promoterId}
            onChange={@handleInputChange}
            placeholder={@props.placeholder || 'Enter Promoter ID'}
          />

          {if @state.saving
            <Spinner inline />
          }
        </div>
      </section>
    </div>
